wizardCtrl.$inject = ['$scope', '$state', 'events']

export default function wizardCtrl($scope, $state, events) {
  var _self = this
  this.classForState = function(stateName) {
    var classes = []
    if ($state.current.name === stateName) {
      classes.push('active')
    }
    var step = parseInt(stateName.substr(-1))
    var currentStep = parseInt($state.current.name.substr(-1))
    if (currentStep > step) {
      classes.push('completed')
    }
    return classes.join(' ')
  }

  $scope.$on(events.DOMAIN_SELECTED, function(e, domain) {
    console.log(domain)
    _self.domainName = domain.name
    _self.domainUuid = domain.uuid
  })
}
